import React, {useState, useEffect, useRef, useMemo} from 'react';

import IfRender from 'components/IfRender';
import redirectLogin from 'fetch/redirectLogin'
import { showToast } from '@turingshequ/react-toast'
import Item from '../Item';
import {MyStatics} from 'fetch/user';
import service, {API} from 'fetch/service';
import {num2likestr} from 'util/index';
import {editIcon, defaultAvatar} from 'assets';
import {list, Info} from './constants';

import ToReport, { REPORT_TYPE } from 'pages/work/ToReport';
import SimpleModal from 'components/Modal/simpleModal';

import s from './index.module.scss';

const DEFAULT_INTRO = 'Hello world, Happy coding～';

interface Props {
  userId?: string | undefined
  isSelf: boolean
  isLogin: boolean
  onReportSuccess: () => void
}

const MAX_LENGTH = 50;

const InfoFC: React.FC<Props> = ({
  userId,
  isSelf,
  isLogin,
  onReportSuccess
}) => {

  const [isEdit, setIsEdit] = useState(false);
  const [infoList, setInfoList] = useState([] as Info[]);
  const [reportBtn, showReportBtn] = useState(false);

  const [newIntro, setNewIntro] = useState('');
  const [infoData, setInfoData] = useState({} as MyStatics);

  const editInput = useRef<HTMLInputElement>(null);


  const staticsFetch = useMemo(
    () => {
      if(isSelf) {
        return service.get(API.user.myStatics)
      }else {
        return service.get(API.user.hisStatics, {
          params: {userId}
        })
      }
    },
    [isSelf, userId],
  )

  const fetchInfo = () => {
    staticsFetch.then((res) => {
      const infoData = res?.data || {};
      setNewIntro(infoData?.intro);
      setInfoData(infoData)
      const newList = list.map(item => {
        const key = item.numKey;
        return {
          ...item,
          num: infoData[key]
        }
      })
      setInfoList(newList)
    })
  }

  useEffect(() => {
    fetchInfo();
  }, [isSelf])

  const handleSaveIntro = () => {
    const value = editInput?.current?.value || '';
    if(value === newIntro) {
      setIsEdit(false)
      return;
    }
    service.post(API.user.saveIntro, value).then(() => {
      showToast({type: 'default',message: '个人签名已更新～'})
      setIsEdit(false);
      setNewIntro(value);
    }).catch(() => {
      setIsEdit(false)
      showToast({type: 'error',message: '修改未成功请稍后再试~'})
    })
  }

  const handleEdit = () => {
    setIsEdit(true)
    setTimeout(() => {
      editInput.current?.focus();
    }, 100)
  }

  const handleReport = () => {
    if(!isLogin) {
      redirectLogin();
      return
    }
    if(infoData.hasReported) {
      showToast({
          type: 'default',
          message: '您已举报过该作者，小图灵正在处理中，请耐心等待～',
        })
      return;
    }
    SimpleModal.show(
      <ToReport
        onClose={() => {
          fetchInfo();
          onReportSuccess();
          SimpleModal.close();
        }}
        id={userId as string}
        type={REPORT_TYPE.user}
      />
    )
  }

  const handleShowReportBtn = () => {
    if(isSelf) {
      return
    }
    showReportBtn(true);
  }

  const avatar = infoData.inBlacklist ? defaultAvatar : infoData.img;

  return (
    <div className={s.information}>
      <div
        onMouseEnter={handleShowReportBtn}
        onMouseLeave={() => showReportBtn(false)}
      >
      <div className={s.avatar}>
        <img src={avatar} alt="" />
      </div>
      <div className={s.name}>
        <div className={s.nameText}>
          {infoData.nickName}
          {reportBtn && <span onClick={handleReport} className={s.reportBtn}>举报</span>}
        </div>
      </div>
      <div className={s.desc}>
        <IfRender show={isEdit}>
          <div>
            <input
              defaultValue={newIntro || infoData?.intro}
              ref={editInput}
              maxLength={MAX_LENGTH}
              className={s.editInput}
              onBlur={handleSaveIntro}
            />
          </div>
        </IfRender>
        <IfRender show={!isEdit}>
          <span>{newIntro || infoData?.intro || DEFAULT_INTRO}</span>
        </IfRender>
        <IfRender show={isSelf && !isEdit && !infoData.inBlacklist}>
         <img src={editIcon} alt="编辑小icon" onClick={handleEdit} />
        </IfRender>
      </div>
      </div>
      <div className={s.achievement}>
        {
          infoList.map(item =>
            <Item
              icon={item.icon}
              key={item.key}
              title={item.title}
              number={num2likestr(item.num)}
            />
          )
        }
      </div>
    </div>
  )
}

export default InfoFC;
